import React, { useState } from "react";
import VehicleMake from "./VehicleMake";
import OwnerDetails from "./OwnerDetails";
import SgNumbers from "./SgNumbers";
import { nanoid } from "nanoid";
import GolfCart from "./GolfCart";
import axios from "axios";
export default function Vehicles() {
  const [submit, setSubmit] = useState({
    submit: false,
  });
  const [allInfo, setAllInfo] = useState({
    email: "",
    sgnumber: "",
    associations: [],
    vehicles: [
      {
        make: "",
        make_name_api: "",
        model: "",
        models: [],
        year: "",
        color: "",
        registration: "",
        checkbox: false,
      },
    ],
  });

  function AddVehicle() {
    setAllInfo((prevState) => ({
      ...prevState,
      vehicles: [
        ...allInfo.vehicles,
        {
          make: "",
          model: "",
          models: [],
          year: "",
          color: "",
          registration: "",
          checkbox: false,
        },
      ],
    }));
  }
  function AddGolfCart() {
    setAllInfo((prevState) => ({
      ...prevState,
      vehicles: [
        ...allInfo.vehicles,
        {
          make: "Golf Cart",
          model: "",
          models: [],
          year: "",
          color: "",
          registration: "",
          checkbox: false,
        },
      ],
    }));
  }
  function handleSgnumber(event) {
    event.preventDefault();
    setAllInfo((prevState) => ({
      ...prevState,
      sgnumber: event.target.value,
    }));
  }

  function RemoveVehicle(event, index) {
    event.preventDefault();
    let newArray = [...allInfo.vehicles];
    console.log(newArray);
    console.log(index);

    var removed = newArray.filter((item, i) => {
      return i !== index;
    });
    console.log(removed);
    setAllInfo((prevState) => ({
      ...prevState,
      vehicles: [...removed],
    }));
  }
  async function handleEmail(event) {
    event.preventDefault();
    setAllInfo((prevState) => ({
      ...prevState,
      email: event.target.value,
    }));
    const options = {
      method: "GET",
      url: `/.netlify/functions/todo`,
      params: {
        email: event.target.value,
      },
    };
    axios
      .request(options)
      .then((response) => {
        if (response.data.vehicleInfo.length === 0) {
          return;
        }
        console.log(response);
        const vehicles = response.data.vehicleInfo;
        let newArray = [];
        for (let i = 0; i < vehicles.length; i++) {
          const model = window.$models.filter(
            (item) => item.make === vehicles[i].vehicle_make
          );
          newArray.push({
            make: vehicles[i].vehicle_make,
            model: vehicles[i].vehicle_model,
            make_name_api:
              "vehicle_make_" +
              vehicles[i].vehicle_make.toLowerCase().split(" ").join("_"),
            models: [...model[0].options],
            year: vehicles[i].vehicle_year_model,
            color: vehicles[i].vehicle_color,
            registration: vehicles[i].vehicle_registration_number,
            checkbox: false,
          });
        }
        setAllInfo((prevState) => ({
          ...prevState,
          sgnumber: vehicles[0].sg_numbers_dropdown,
          vehicles: [...newArray],
          associations: response.data.associations,
        }));
      })
      .catch((err) => console.log(err));
  }
  function handleMake(event, index) {
    event.preventDefault();
    const model = window.$models.filter(
      (item) => item.make === event.target.value
    );
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          make: event.target.value,
          make_name_api:
            "vehicle_make_" +
            event.target.value.toLowerCase().split(" ").join("_"),
          models: [...model[0].options],
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  function handleModel(event, index) {
    event.preventDefault();
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          model: event.target.value,
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  function handleRegistration(event, index) {
    event.preventDefault();
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          registration: event.target.value,
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  function handleYear(event, index) {
    event.preventDefault();
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          year: event.target.value,
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  function handleColor(event, index) {
    event.preventDefault();
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          color: event.target.value,
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  async function handleSubmit() {
    if (allInfo.vehicles.length === 0) {
      alert("You need to submit at least one Vehicle or Golf Cart");
      return;
    }
    for (let i = 0; i < allInfo.vehicles.length; i++) {
      if (allInfo.vehicles[i].make === "Golf Cart") {
        if (
          allInfo.email === "" ||
          allInfo.sgnumber === "" ||
          allInfo.vehicles[i].color === ""
        ) {
          alert("Please complete the form!");
          return;
        }
      } else {
        if (
          allInfo.email === "" ||
          allInfo.sgnumber === "" ||
          allInfo.vehicles[i].make === "" ||
          allInfo.vehicles[i].model === "" ||
          allInfo.vehicles[i].year === "" ||
          allInfo.vehicles[i].color === "" ||
          allInfo.vehicles[i].registration === ""
        ) {
          alert("Please complete the form!");
          return;
        }
      }
    }
    let newArray = [];
    for (let i = 0; i < allInfo.vehicles.length; i++) {
      newArray.push({
        make: allInfo.vehicles[i].make,
        make_name_api: allInfo.vehicles[i].make_name_api,
        model: allInfo.vehicles[i].model,
        year: allInfo.vehicles[i].year,
        color: allInfo.vehicles[i].color,
        registration: allInfo.vehicles[i].registration,
        checkbox: allInfo.vehicles[i].checkbox,
      });
    }
    let submitObject = {
      email: allInfo.email,
      sgnumber: allInfo.sgnumber,
      associations: allInfo.associations,
      vehicles: newArray,
    };
    const options = {
      method: "GET",
      url: `/.netlify/functions/submitData`,
      params: {
        data: JSON.stringify(submitObject),
      },
    };

    axios
      .request(options)
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
    setSubmit({
      submit: true,
    });
  }

  function handleCheckBox(event, index) {
    event.preventDefault();
    let newArray = allInfo.vehicles.map((item, i) => {
      if (index == i) {
        return {
          ...item,
          checkbox:
            event.target.type === "checkbox"
              ? event.target.checked
              : event.target.value,
        };
      }
      return item;
    });

    setAllInfo((prevChose) => ({
      ...prevChose,
      vehicles: [...newArray],
    }));
  }
  const vehicleElements = allInfo.vehicles.map((item, i) => {
    if (item.make === "Golf Cart") {
      return (
        <GolfCart
          key={nanoid()}
          color={allInfo.vehicles[i].color}
          handleColor={(event) => handleColor(event, i)}
          removeVehicle={(event) => RemoveVehicle(event, i)}
          index={i}
        />
      );
    }
    return (
      <VehicleMake
        key={nanoid()}
        make={allInfo.vehicles[i].make}
        model={allInfo.vehicles[i].model}
        models={allInfo.vehicles[i].models}
        year={allInfo.vehicles[i].year}
        color={allInfo.vehicles[i].color}
        registration={allInfo.vehicles[i].registration}
        handleMake={(event) => handleMake(event, i)}
        handleModel={(event) => handleModel(event, i)}
        handleYear={(event) => handleYear(event, i)}
        handleColor={(event) => handleColor(event, i)}
        handleRegistration={(event) => handleRegistration(event, i)}
        handleCheckBox={(event) => handleCheckBox(event, i)}
        removeVehicle={(event) => RemoveVehicle(event, i)}
        checkbox={allInfo.vehicles[i].checkbox}
        index={i}
      />
    );
  });

  if (submit.submit === true) {
    window.scrollTo(0, 0);
    return (
      <div className={"submission"}>
        <h1>Thank you for your submission!</h1>
      </div>
    );
  }
  return (
    <div className="ownerdetails_vehicles">
      <h1>Vehicle Enrolment</h1>
      <OwnerDetails
        handleEmail={(event) => handleEmail(event)}
        email={allInfo.email}
      />
      <SgNumbers
        sgnumber={allInfo.sgnumber}
        handleSgnumber={(event) => handleSgnumber(event)}
      />
      {vehicleElements}
      <div className={"add_remove_buttons"}>
        <button onClick={() => AddGolfCart()}>
          <h3>ADD GOLF CART</h3>
        </button>
        <button onClick={() => AddVehicle()}>
          <h3>ADD VEHICLE</h3>
        </button>
      </div>
      <button className={"submit_button"} onClick={() => handleSubmit()}>
        <h3>SUBMIT</h3>
      </button>
    </div>
  );
}
